import React, { useState, useEffect } from 'react';
import './Dashboard.css'; 
import Sidebar from './Sidebar';
import contactService from '../../api/contactService';

const AdminContact = () => {
  const [isToggled, setIsToggled] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  
  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10; // Increased for contact list

  // Contact Data State
  const [contactData, setContactData] = useState([]);

  // --- API LOGIC ---
  const fetchContacts = async () => {
    try {
      setLoading(true);
      const data = await contactService.getAllContact();
      // Accessing the 'data' array from your JSON structure
      setContactData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Failed to load contacts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this inquiry?")) {
      try {
        await contactService.deleteProject(id);
        setContactData(prev => prev.filter(item => item._id !== id));
      } catch (error) {
        alert("Delete failed: " + error);
      }
    }
  };

  // --- UI LOGIC ---
  // Search by Name, Email, or Service
  const filteredContacts = contactData.filter(contact => {
  // Convert everything to a string safely to avoid "is not a function" errors
  const name = contact.name?.toLowerCase() || "";
  const phone = String(contact.phoneNumber || ""); // Force string conversion
  const service = contact.services?.toLowerCase() || "";
  
  const term = searchTerm.toLowerCase();

  return (
    name.includes(term) ||
    phone.includes(searchTerm) || // Search phone without lowercase logic
    service.includes(term)
  );
});

  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const currentRecords = filteredContacts.slice(firstIndex, lastIndex);
  const nPages = Math.ceil(filteredContacts.length / recordsPerPage);

  return (
    <div className={`d-flex ${isToggled ? 'toggled' : ''}`} id="wrapper">
      <Sidebar />

      <div id="page-content-wrapper" className="bg-light flex-grow-1">
        <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom px-4 shadow-sm sticky-top">
          <div className="d-flex align-items-center w-100">
            <i className="bi bi-list fs-4 me-3 cursor-pointer" onClick={() => setIsToggled(!isToggled)}></i>
            <h5 className="mb-0 fw-bold">Management Panel</h5>
            <div className="ms-auto">
                <span className="text-muted small fw-medium">Admin / Contact Inquiries</span>
            </div>
          </div>
        </nav>

        <div className="container-fluid p-4">
          <div className="card border-0 shadow-sm" style={{ borderRadius: '15px', overflow: 'hidden' }}>
            
            <div className="card-header bg-white border-0 pt-4 px-4 pb-2">
              <div className="mb-3">
                <h6 className="fw-bold mb-0" style={{ color: '#1e293b', fontSize: '18px' }}>Contact Inquiries</h6>
                <p className="text-muted mb-0" style={{ fontSize: '12.5px' }}>
                  {loading ? 'Syncing...' : `Total ${filteredContacts.length} inquiries received.`}
                </p>
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="input-group shadow-sm" style={{ width: '400px', borderRadius: '10px', overflow: 'hidden' }}>
                  <span className="input-group-text bg-white border-end-0 px-3">
                    <i className="bi bi-search text-muted"></i>
                  </span>
                  <input 
                    type="text" 
                    className="form-control border-start-0 ps-1" 
                    placeholder="Search by name, phoneNumber or service..." 
                    onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
                  />
                </div>
              </div>
            </div>
            
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="bg-light">
                    <tr className="text-muted text-uppercase" style={{ fontSize: '11px', fontWeight: '700' }}>
                      <th className="ps-4 py-3">S.No</th>
                      <th>User Info</th>
                      <th>Service Requested</th>
                      <th>Message</th>
                      <th>Date</th>
                      <th className="text-end pe-4">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                       <tr><td colSpan="6" className="text-center py-5">Loading inquiries...</td></tr>
                    ) : currentRecords.length > 0 ? (
                      currentRecords.map((item, index) => (
                        <tr key={item._id}>
                          <td className="ps-4 text-muted">{firstIndex + index + 1}</td>
                          <td className="py-3">
                            <div>
                              <div className="fw-bold" style={{ fontSize: '14px', color: '#1e293b' }}>{item.name}</div>
                              <div className="text-primary small">{item.email}</div>
                              <small className="text-muted">{item.phoneNumber}</small>
                            </div>
                          </td>
                          <td>
                            <span className="badge bg-info-subtle text-info border fw-normal">
                              {item.services}
                            </span>
                          </td>
                          <td style={{ maxWidth: '300px' }}>
                            <div className="text-truncate small" title={item.message}>
                              {item.message}
                            </div>
                          </td>
                          <td className="small">
                            {new Date(item.createdAt).toLocaleDateString()}
                          </td>
                          <td className="text-end pe-4">
                            <button className="btn btn-sm btn-light border shadow-sm" onClick={() => handleDelete(item._id)}>
                              <i className="bi bi-trash text-danger"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr><td colSpan="6" className="text-center py-5 text-muted">No inquiries found.</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="card-footer bg-white border-0 py-3 px-4 d-flex justify-content-between align-items-center">
              <small className="text-muted">
                Showing {currentRecords.length} entries
              </small>
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>Previous</button>
                  </li>
                  {[...Array(nPages)].map((_, i) => (
                    <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === nPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>Next</button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminContact;